import { render, staticRenderFns } from "./CatalogFilter.vue?vue&type=template&id=45d455b7&scoped=true&"
import script from "./CatalogFilter.vue?vue&type=script&lang=js&"
export * from "./CatalogFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d455b7",
  null
  
)

export default component.exports